const ThirdSection = () => {
    return <div className="third-section">
        <div className="left">
            Our trajectory it started in 1986,
        </div>
        <div className="right">Since then, we have developed more than 250 million
            square meters in several highly relevant and successful projects in Brazil and abroad.</div>
    </div>
}

export default ThirdSection